class SectionTabs extends HTMLElement {
	constructor() {
		super();

		this.sections = JSON.parse(this.getAttribute('sections'));
		this.tabs = this.querySelectorAll('a');

		const path = window.location.pathname;
		const pathEnd = path.split('/').pop();

		for (const tab of this.tabs) {
			if (tab.dataset.section == pathEnd) {
				this.selectTab(tab);
			}

			tab.addEventListener('click', e => {
				e.preventDefault();
				this.selectTab(tab);
			});
		}
	}

	selectTab(tab) {
		if (tab.getAttribute('aria-selected') == 'true') return;

		this.tabs.forEach(tab => tab.setAttribute('aria-selected', 'false'));
		tab.setAttribute('aria-selected', 'true');

		const path = window.location.pathname;
		const pathEnd = path.split('/').pop();

		if (tab.dataset.section) {
			const newPath = this.sections.includes(pathEnd) ? path.replace(pathEnd, tab.dataset.section) : `${path}/${tab.dataset.section}`;
			window.history.replaceState({}, '', newPath);
		}
		else window.history.replaceState({}, '', path.replace(`/${pathEnd}`, ''));

		setTimeout(() => tab.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'}));

		for (const sectionId of this.sections) {
			const section = document.querySelector(`#${sectionId}`);
			if (!section) continue;

			if (sectionId == tab.dataset.section || !tab.dataset.section) section.style.display = '';
			else section.style.display = 'none';
		}
	}
}

customElements.define('section-tabs', SectionTabs);